// extracted by mini-css-extract-plugin
export default {"endCode":"ValuesSchema_endCode__EH8vs","title":"ValuesSchema_title__g8VXn","modalDialog":"ValuesSchema_modalDialog__BtfgD","modalFooter":"ValuesSchema_modalFooter__D-v01"};